var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-responsive', {
    staticClass: "mx-auto mb-4",
    attrs: {
      "max-width": "800"
    }
  }, [_c('v-card', {
    staticClass: "overflow-y-auto show-on-print",
    attrs: {
      "max-height": "600"
    }
  }, [_c('v-card-text', {
    staticClass: "font-weight-bold",
    domProps: {
      "innerHTML": _vm._s(_vm.termoEmHtml)
    }
  })], 1), _c('v-container', {
    staticClass: "px-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.usuario.termoLgpdAceito
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_c('div', [_vm._v(" Eu " + _vm._s(_vm.$user.fullName) + ", CPF Nº " + _vm._s(_vm.$formatCpf(_vm.$user.username)) + ", concordo com os itens listados do "), _c('span', {
          staticClass: "blue--text"
        }, [_vm._v(" Termo de consentimento do uso de dados pessoais. ")])])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.checkbox,
      callback: function ($$v) {
        _vm.checkbox = $$v;
      },
      expression: "checkbox"
    }
  })], 1), _c('v-row', {
    staticClass: "d-block text-center btn-group"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm.acao.descricao === 'Aceitar' || _vm.acao.descricao === 'Ciente' ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.checkbox
    },
    on: {
      "click": _vm.aceitarTermo
    }
  }, [_vm._v(" " + _vm._s(_vm.buttonText) + " ")]) : _vm.acao.descricao === 'Participar/Não Participar' ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.checkbox
    },
    on: {
      "click": _vm.aceitarTermo
    }
  }, [_vm._v(" Participar ")]) : _vm._e(), _vm.acao.descricao === 'Participar/Não Participar' ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "outlined": ""
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v(" Não Participar ")]) : _vm._e()], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }